/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const propertiesTypeByProduct = {
    1001: 'flower', // 1800flowers
    1019: 'food', // harryanddavid
    1009: 'flower', // 1800baskets
    1025: 'food', // simplychocolate
    1010: 'flower', // fruitbouquets
    1012: 'food', // cheryls
    1022: 'flower', // personalizationuniverse
    1002: 'food', // thepopcornfactory
    1020: 'food', // wolfermans
    1018: 'food', // stockyards
    1029: 'flower', // berries
    1030: 'pmall', // personalizationmall
    1031: 'food', // 'vitalchoice',
    1027: 'flower', // 'the market',
    1034: 'flower', // florists //copied from flowers needs confirmation
};

export const inputProperties = {
    Residence: {
        message: 'Please remember to include an apartment or unit number in "Address Line 2" if available.',
        formFieldLabels: {
            firstAndLastName: 'Recipient\'s First and Last Name',
            firstName: 'Recipient\'s First Name',
            lastName: 'Recipient\'s Last Name',
            locationType: 'Location Type',
            address1: 'Delivery Address',
            address2: 'Apt/Suite/Room',
            city: 'City',
            state: 'State',
            country: 'Country',
            zipCode: 'Zip Code',
            phone: 'Recipient Phone Number',
        },
        toolTipText: 'If there\'s a delivery issue, ie. the recipient is not at home, we\'ll call them to make sure we can deliver their gift.',
    },
    Business: {
        message: 'Please remember to include a suite or unit number in "Address Line 2" if available.',
        formFieldLabels: {
            firstAndLastName: 'First and Last Name',
            firstName: 'First Name',
            lastName: 'Last Name',
            locationType: 'Location Type',
            organizationName: 'Company Name',
            address1: 'Delivery Address',
            address2: 'Apt/Suite/Room',
            city: 'City',
            state: 'State',
            zipCode: 'Zip Code',
            country: 'Country',
            phone: 'Recipient Phone Number',
        },
        toolTipText: 'If there\'s a delivery issue, ie. the recipient is not at work, we\'ll call them to make sure we can deliver their gift.',
    },
    'Funeral home': {
        message: 'If you need special assistance regarding you funeral order, please contact one of our Special Sympathy Advisors at (866)-538-2259',
        formFieldLabels: {
            firstAndLastName: 'Deceased First and Last Name',
            firstName: 'Deceased First Name',
            lastName: 'Deceased Last Name',
            locationType: 'Location Type',
            organizationName: 'Funeral Home Name',
            address1: 'Delivery Address',
            address2: 'Apt/Suite/Room',
            city: 'City',
            state: 'State',
            zipCode: 'Zip Code',
            country: 'Country',
            phone: 'Funeral Home Telephone',
        },
        toolTipText: '"If there\'s a delivery issue, ie. the service started earlier or later , we\'ll call them to make sure we can deliver the arrangement.',
    },
    Hospital: {
        message: 'Patients in emergency rooms or ICU/CCU units may not be able to receive deliveries.',
        formFieldLabels: {
            firstAndLastName: 'First and Last Name',
            firstName: 'First Name',
            lastName: 'Last Name',
            locationType: 'Location Type',
            organizationName: 'Hospital Name',
            address1: 'Delivery Address',
            address2: 'Apt/Suite/Room',
            city: 'City',
            state: 'State',
            zipCode: 'Zip Code',
            country: 'Country',
            phone: 'Recipient Phone Number',
        },
        toolTipText: 'If there\'s a delivery issue, ie. the patient was moved to different unit, we\'ll call them to make sure we can deliver their gift',
    },
    School: {
        message: 'Due to many school\'s security regulations, delivery to schools may not be guaranteed.',
        formFieldLabels: {
            firstAndLastName: 'First and Last Name',
            firstName: 'First Name',
            lastName: 'Last Name',
            locationType: 'Location Type',
            organizationName: 'School Name',
            address1: 'Delivery Address',
            address2: 'Apt/Suite/Room',
            city: 'City',
            state: 'State',
            zipCode: 'Zip Code',
            country: 'Country',
            phone: 'Recipient Phone Number',
        },
        toolTipText: 'If there\'s a delivery issue, ie. the recipient is not at school, we\'ll call them to make sure we can deliver their gift',
    },
    Church: {
        message: 'If you need special assistance regarding a memorial service, please contact one of our Special Sympathy Advisors at (866)-538-2259.',
        formFieldLabels: {
            firstAndLastName: 'First and Last Name',
            firstName: 'First Name',
            lastName: 'Last Name',
            locationType: 'Location Type',
            organizationName: 'Church Name',
            address1: 'Delivery Address',
            address2: 'Apt/Suite/Room',
            city: 'City',
            state: 'State',
            zipCode: 'Zip Code',
            country: 'Country',
            phone: 'Recipient Phone Number',
        },
        toolTipText: 'If there\'s a delivery issue, ie. the recipient is not at home, we\'ll call them to make sure we can deliver their gift.',
    },
    Apartment: {
        message: 'Please remember to include an apartment or unit number in "Address Line 2" if available.',
        formFieldLabels: {
            firstAndLastName: 'First and Last Name',
            firstName: 'First Name',
            lastName: 'Last Name',
            locationType: 'Location Type',
            address1: 'Delivery Address',
            address2: 'Apt/Suite/Room',
            city: 'City',
            state: 'State',
            country: 'Country',
            zipCode: 'Zip Code',
            phone: 'Recipient Phone Number',
        },
        toolTipText: 'If there\'s a delivery issue, ie. the recipient is not at home, we\'ll call them to make sure we can deliver their gift.',
    },
};

export const inputPropertiesFood = {
    Residence: {
        message: 'Please remember to include an apartment or unit number in "Address Line 2" if available.',
        formFieldLabels: {
            firstAndLastName: 'Recipient\'s First and Last Name',
            firstName: 'Recipient\'s First Name',
            lastName: 'Recipient\'s Last Name',
            locationType: 'Location Type',
            address1: 'Delivery Address',
            address2: 'Apt/Suite/Room',
            city: 'City',
            state: 'State',
            country: 'Country',
            zipCode: 'Zip Code',
            phone: 'Recipient Phone Number',
        },
        toolTipText: 'If there\'s a delivery issue, ie. the recipient is not at home, we\'ll call them to make sure we can deliver their gift.',
    },
    Business: {
        message: 'Please remember to include a suite or unit number in "Address Line 2" if available.',
        formFieldLabels: {
            firstAndLastName: 'First and Last Name',
            firstName: 'First Name',
            lastName: 'Last Name',
            locationType: 'Location Type',
            organizationName: 'Company Name',
            address1: 'Delivery Address',
            address2: 'Apt/Suite/Room',
            city: 'City',
            state: 'State',
            zipCode: 'Zip Code',
            country: 'Country',
            phone: 'Recipient Phone Number',
        },
        toolTipText: 'If there\'s a delivery issue, ie. the recipient is not at work, we\'ll call them to make sure we can deliver their gift.',
    },
    POBox: {
        formFieldLabels: {
            firstAndLastName: 'Recipient\'s First and Last Name',
            firstName: 'Recipient\'s First Name',
            lastName: 'Recipient\'s Last Name',
            locationType: 'Location Type',
            address1: 'P.O. Box',
            address2: 'Apt/Suite/Room',
            city: 'City',
            state: 'State',
            country: 'Country',
            zipCode: 'Zip Code',
            phone: 'Recipient Phone Number',
        },
    },
    APOFPO: {
        formFieldLabels: {
            firstAndLastName: 'Recipient\'s First and Last Name',
            firstName: 'Recipient\'s First Name',
            lastName: 'Recipient\'s Last Name',
            locationType: 'Location Type',
            address1: 'Unit/Ship/PSC Number',
            address2: 'Box/Hull Number',
            city: 'City',
            state: 'State',
            country: 'Country',
            zipCode: 'Zip Code',
            phone: 'Recipient Phone Number',
        },
        toolTipText: 'APO/FPO Address Help.When ordering, choose APO/FPO MILITARY and select from the Armed Forces delivery locations within the State drop down menu field. Please allow at least 5 weeks transit time for delivery.',
    },
};

export const inputPropertiesPmall = {
    ...inputProperties,
    POBox: inputPropertiesFood.POBox,
    APOFPO: inputPropertiesFood.APOFPO,
};

export const getInputProperties = (type) => {
    if (type === 'food') {
        return inputPropertiesFood;
    } if (type === 'pmall') {
        return inputPropertiesPmall;
    }

    return inputProperties;
};

const getListLocationTypes = (presentationFamily) => {
    const locationTypes = Object.keys(getInputProperties(presentationFamily));
    const locationTypeArray = locationTypes.map((location) => {
        let valueDisplay = null;

        if (location === 'POBox') {
            valueDisplay = 'P.O. Box';
        } else if (location === 'APOFPO') {
            valueDisplay = 'APO/FPO';
        }

        return ({
            key: location,
            value: valueDisplay || location,
        });
    });

    return locationTypeArray;
};

export default getListLocationTypes;
